<script>
/**
 * SubForm | Sample
 * 
 * Permite la edición parcial de componentes de formulario en contexto 
 * aside para automodal.vue, solo requiere que se pase en v-model el "form" completo.
 * 
 * P. e:
 * <sub-form-inputs v-model="form" />
 * 
 * Está establecido en workingValue: {} los componentes que modificará directamente éste
 * componente en form. 
 * 
 * El resto se traerá de manera automática.
 * 
 * #bug
 * Hay un error conocido en fechas, puede haber en otros tipos
 * de datos diferentes.
 * 
 * @author Daniel Lepe
 * @version 1.0
 * @date 7/jan/2023
 */
import _ from 'lodash';
export default {
    name: 'SubFormInputs',
    props: {
        value: {
            type: Object
        }
    },
    data: () => {
        return {
            workingValue: {
                // ANY FIELD HERE REQUIRE HIS HOMOLOGATION IN WATCHER
                pedido_fechaEntrega: null,
                pedido_especificacionesPedido: null
            }
        }
    },
    watch: {
        'value.pedido_fechaEntrega'(){
            this.localHomolage('pedido_fechaEntrega')
        },
        'value.pedido_especificacionesPedido'(){
            this.localHomolage('pedido_especificacionesPedido')
        }
    },
    computed: {
        mergedValue(){
            let merged = _.cloneDeep(this.value);
            _.forEach(this.workingValue, (itemVal, item) => {
                merged[item] = _.clone(itemVal);
            })
            return merged;
        }
    },
    beforeMount() {
        _.forEach(this.workingValue, (itemValue, item) => {
            this.workingValue[item] = _.clone(this.value[item])
        })
    },
    methods: {
        triggerEmit(){
            this.$emit('input', this.mergedValue)
        },
        localHomolage(item){
            if(this.workingValue[item] != this.value[item])
                this.workingValue[item] = _.clone(this.value[item])
        }
    }
}
</script>

<template>
    <div id="SubFormInputs">
        <div class="ui-input-handler">

            <!-- FECHA DE ENTREGA -->
            <b-form-group label="Fecha entrega pedido" label-for="pedido_fechaEntrega" v-if="!value.id">
                <b-form-input id="pedido_fechaEntrega" type="date" v-model="workingValue.pedido_fechaEntrega" @change="triggerEmit"/>
            </b-form-group> 

            <slot name="default"></slot>

            <!-- COMENTARIOS DE PEDIDO -->
            <b-form-group label="Especificaciones pedido" class="mt-3" label-for="pedido_especificacionesPedido"  v-if="!value.id">
                <b-form-textarea id="pedido_especificacionesPedido" 
                    v-model="workingValue.pedido_especificacionesPedido" 
                    :rows="3"
                    :max-rows="6"
                    @change="triggerEmit"/>
            </b-form-group>

        </div>
    </div>
</template>